import React from 'react';

const MetricCard = ({
  icon: Icon,
  title,
  value,
  subtext,
  color = 'text-gray-900',
  bgColor = 'bg-white',
  iconBg = 'bg-blue-100',
  percent,
  highlight = false,
  className = ''
}) => (
  <div className={`flex flex-col rounded-xl shadow p-3 ${bgColor} ${highlight ? 'ring-2 ring-blue-400' : ''} ${className}`}>
    <div className='flex items-center mb-1'>
      {Icon && (
        <div className={`p-1 rounded-lg mr-2 ${iconBg}`}>
          <Icon className='w-4 h-4' />
        </div>
      )}
      <span className={`font-semibold text-sm ${color}`}>{title}</span>
    </div>
    <div className={`font-extrabold text-base ${color}`}>{value}</div>
    {percent !== undefined && (
      <div className='text-xs text-gray-500 mt-0.5'>{percent}</div>
    )}
    {subtext && <div className='text-xs text-gray-500 mt-1'>{subtext}</div>}
  </div>
);

export default MetricCard; 